

// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import summaryApi from "../common/Api";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import Loading from "../components/loading/loading";
import moment from "moment";
const AllOrders = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getOrder = async () => {
    const tokenApi = Cookies.get("tokenApi");
    if (!tokenApi) {
      toast.error("Authentication token is missing. Please log in again.", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
      });
      return;
    }
    try {
      const response = await axios.get(summaryApi.getAllOrders.url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
      });
      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      toast.error("Failed to fetch order data.");
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrder();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div style={styles.container}>
          <h2 className="pt-2 font-bold text-3xl" style={styles.title}>
            Order Summary
          </h2>
          <h2 className='font-bold py-2  text-xl'>Search Result: {data.length} </h2>
           <div style={{maxHeight:"calc(100vh - 250px)"}} className=" md:w-[95%] py-2 overflow-auto  overflow-x-hidden max-h-[calc(100vh - 250px)] sm:max-h-[300px] md:max-h-[400px] lg:max-h-[calc(100vh-500px)] xl:max-h-[100vh]">
           {data.length > 0 ? (
            data.map((order, orderIndex) => (
              <div key={order._id} style={styles.orderCard}>
                <h3 className="text-lg md:text-2xl font-bold" style={styles.orderTitle}>
                  {moment(order.createdAt).format("L")} - Total:{" "}
                  {order.totalAmount} EGP
                </h3>

                {/* Product Details */}
                <div
                  className="overflow-x-scroll md:overflow-hidden scroll-smooth"
                  style={{
                    WebkitOverflowScrolling: "touch", // Smooth scroll for iOS Safari
                    scrollbarWidth: "thin", // Firefox scrollbar width
                  }}
                >
                  <h4 className="font-bold" style={styles.sectionTitle}>
                    Product Details
                  </h4>
                  {/* style={{width: "100vh"}} */}
                  <table className="md:w-full w-[100vh]  border-collapse">
                    <thead>
                      <tr>
                        <th>Product ID</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody className="text-slate-500 text-center  ">
                      {order.productDetails.map((product, index) => (
                        <tr key={index}>
                          <td>{product.productId}</td>
                          <td>{product.name}</td>
                          <td>{product.price} EGP</td>
                          <td>{product.quantity}</td>
                          <td className="image-container flex justify-center items-center">
                            {product.image?.[0] && (
                              <img
                                src={product.image[0]}
                                alt={product.name}
                                style={styles.image}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Payment Details */}
                <div>
                  <h4 className="font-bold" style={styles.sectionTitle}>
                    Payment Details
                  </h4>
                  <div className="flex items-center md:gap-2 flex-nowrap">
                    <strong className=" w-[110px] ">Payment ID:</strong>{" "}
                    <p className="text-slate-400 text-ellipsis line-clamp-1">
                      {order.paymentDetails.paymentId}
                    </p>{" "}
                  </div>
                  <div className="flex items-center gap-2">
                    <strong>Payment Status:</strong>{" "}
                    <p className="text-slate-400">
                      {order.paymentDetails.paymentStatus}
                    </p>{" "}
                  </div>
                 
                </div>

                {/* Shipping and Meta Details */}
                <div>
                  <h4 className="font-bold" style={styles.sectionTitle}>
                    Shipping Details
                  </h4>
                
                  <div className="flex items-center gap-2">
                    <strong>Shipping Cost:</strong>{" "}
                    <p className="text-slate-500">
                      {order.shipping_options[0]} EGP
                    </p>{" "}
                  </div>
                 
                  <div className="flex items-center gap-2">
                    <strong>User Email:</strong>{" "}
                    <p className="text-slate-500">{order.email}</p>{" "}
                  </div>
                  {/* <p><strong>User ID:</strong> {order.userId}</p> */}
                  <p>
                    <strong>Created At:</strong>{" "}
                    {new Date(order.createdAt).toLocaleString()}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-lg font-bold mt-10">
              <p className="text-gray-600 mt-4">No Data available.</p>
            </div>
          )}
           </div>
        </div>
      )}
    </>
  );
};

// Styles
const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    // backgroundColor: "#f8f9fa",
    borderRadius: "10px",
  },
  title: {
    textAlign: "left",
    marginBottom: "10px",
    color: "#333",
    fontFamily: "serif",
  },
  orderCard: {
    marginBottom: "30px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  orderTitle: {
    marginBottom: "15px",
    color: "#3dacbd",
    // fontSize: "1.4rem",
    fontWeight: "bold",
  },
  sectionTitle: {
    marginTop: "15px",
    marginBottom: "10px",
    color: "#555",
    borderBottom: "1px solid #ddd",
    paddingBottom: "5px",
  },
  table: {
    width: "100vh",
    borderCollapse: "collapse",
  },
  tr: {
    borderBottom: "1px solid #ddd",
  },
  th: {
    padding: "10px",
    border: "1px solid #ddd",
    backgroundColor: "#f1f1f1",
    textAlign: "left",
  },
  td: {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    verticalAlign: "top",
    color: "#94a3b8",
  },
  body: {
    textAlign: "center",
  },
  image: {
    width: "50px",
    height: "50px",
    borderRadius: "5px",
    objectFit: "contain",
  },
};

export default AllOrders;
